import { SlotSymbolInfo, WinReelResult } from '../../domain/placeOrder/api/PlaceOrderResponse'
import { Symbol } from '../Symbol'
import { gameConfig } from '../../config'
import { SymbolType } from '../../domain/game/enum/SymbolType'
import { useEffect, useMemo, useRef } from 'react'
import { multiplierService } from '../../domain/spin/service/MultiplierService'
import { Container, BitmapText } from '@pixi/react'
import { TableSnapshotResponse } from '../../domain/betDetail/api/betDetailResponse'
import { Spine } from '@esotericsoftware/spine-pixi/dist/Spine'
import { preciseMinus, SpinePlayer } from '@slot-nx/core'
import { Container as PixiContainer } from 'pixi.js'

import dataBay from '/resource/spine/symbol/Bay/Multiple.skel?url'

import atlasBay from '/resource/spine/symbol/Bay/Multiple.atlas?url'
import { changeNode } from '../../domain/game/util/gameUtil'
interface ReelTableProps {
  slotTable: SlotSymbolInfo[][]
  winningReels: WinReelResult[]
  // width: number
  // height: number
  x: number
  y: number
}

export const ReelTable = (props: ReelTableProps) => {
  const {
    slotTable,
    winningReels,
    // width,
    // height,
    x,
    y,
  } = props
  const reelRefs = useRef<PixiContainer[]>([])

  const winningMap = useMemo(() => {
    const map = new Map<SymbolType, number>()
    winningReels.forEach((x) => {
      map.set(x.symbol, x.payout)
    })
    return map
  }, [winningReels])

  useEffect(() => {
    const reelTable = reelRefs.current
    reelTable.forEach((reel, reelIndex) => {
      reel.children.forEach((symbol, symbolIndex) => {
        changeNode(symbol as PixiContainer, slotTable[reelIndex][symbolIndex])
      })
    })
  }, [slotTable])

  const Reels = useMemo(() => {
    return (
      slotTable.map((reel, reelIndex) => (
        <Container
          name={`Reel${reelIndex}`}
          key={reelIndex}
          x={reelIndex * gameConfig.nodeWidth}
          ref={(el) => {
            reelRefs.current[reelIndex] = el as PixiContainer
          }}
        >
          {reel.map((symbol, symbolIndex) => (
            <Symbol
              key={`${reelIndex}-${symbolIndex}`}
              x={0}
              y={(4 - symbolIndex) * gameConfig.nodeHeight}
              data={symbol as SlotSymbolInfo}
              alpha={
                winningMap.has(symbol.symbol)
                || (winningMap.size !== 0 && (!winningMap.has(SymbolType.Bonus) && !winningMap.has(SymbolType.SuperBonus)) && symbol.symbol === SymbolType.Multiplier)
                  ? 1
                  : 0.5
              }
            />
          ))}
        </Container>
      ))
    )
  }, [slotTable, winningMap])

  return (
    <Container
      name="reelTable"
      x={x}
      y={y}
      scale={0.75}
    >
      {Reels}
    </Container>
  )
}

interface ReelMultiplierProps {
  snapshot: TableSnapshotResponse
  x: number
  y: number
}
export const ReelMultiplier = (props: ReelMultiplierProps) => {
  const multiplierArray = props.snapshot.multiplierReel
  const spineRef = useRef<Spine>()
  const intervalValue = preciseMinus(multiplierArray[1], multiplierArray[0])
  const multiplierSymbol = useMemo(() => {
    const elements: any[] = []
    for (let i = 0; i < multiplierArray.length; i++) {
      elements.push(
        <Container key={i} alpha={i === 0 ? 1 : 0.6}>
          <SpinePlayer
            onCreatedSpine={spine => spineRef.current = spine}
            playOnLoad={true}
            data={dataBay}
            atlas={atlasBay}
            x={123 * i}
            y={100}
            scale={0.74}
            animationStr={`${multiplierService.getMultiplierAnimationStr(multiplierArray[i], intervalValue)}`}
          />

          <BitmapText
            name="multiplierText"
            text={`x${multiplierArray[i]}`}
            anchor={[0.5, 1]}
            style={{ fontName: 'FontW', fontSize: multiplierService.fontSize(multiplierArray[i]) }}
            y={100}
            x={123 * i}
            scale={0.7}
          />
        </Container>,
      )
    }
    return elements
  }, [intervalValue, multiplierArray])
  return (
    <Container
      x={props.x}
      y={props.y}
    >
      {multiplierSymbol}
    </Container>
  )
}
